import { useQuery } from "@tanstack/react-query";
import { DatastoresIconMap, getIconByDatastoreType } from "@/pages/datasets/DatastoreImage";
import { getDatastoreTypes } from "@/helpers/apis";
import { Button } from "@altimateai/lego";
import { GET_DATASTORE_TYPES } from "./components/DatastoreImage";
import { cn } from "@/lib/utils";

interface Props {
  datastoreType: keyof typeof DatastoresIconMap;
  setDatastoreType: (datastoreType: keyof typeof DatastoresIconMap) => void;
}

const DatastoreTypeIcons = ({ datastoreType, setDatastoreType }: Props) => {
  const { data: datastoreTypes, isLoading } = useQuery({
    queryKey: [GET_DATASTORE_TYPES],
    queryFn: getDatastoreTypes,
  });

  if (isLoading || !datastoreTypes) return null;
  return datastoreTypes
    .filter(ds => ds.is_standalone)
    .map(ds => (
      <Button
        key={ds.value}
        variant={"ghost"}
        disabled={!ds.enabled}
        className={cn(
          "!al-cursor-default al-capitalize al-h-12 al-border hover:al-bg-transparent",
          ds.value === datastoreType ? "!al-border-stroke-brand" : "!al-border-stroke-light"
        )}
        onClick={() => {
          if (!ds.enabled) return;
          setDatastoreType(ds.value as keyof typeof DatastoresIconMap);
        }}
      >
        {getIconByDatastoreType(ds.value, "al-h-8")}
        {ds.value}
      </Button>
    ));
};

export default DatastoreTypeIcons;
